import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import {
  Created_Case,
  ConfTab,
  Processed_musterlsg,
  Section,
} from '../utils/interfaces';
import { AuthService } from '@shared/services/auth.service';
import { DataService } from '@shared/services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CaseApiService,
  CaseDataService,
  CustomToastrService,
  PocketbaseService,
  SpinnerService
} from '@shared/services';
import { take } from 'rxjs/operators';
import { CreateCaseEditorTabs } from '../create-case-editor/models';
import { LEGAL_TAGS_BY_CATEGORY, LegalCategory } from '../create-case-editor/config/legal-tags.config';

@Component({
  selector: 'app-create-case',
  templateUrl: './create-case.component.html',
  styleUrls: ['./create-case.component.css']
})
export class CreateCaseComponent implements OnInit, OnDestroy {
  private readonly pocketbaseService = inject(PocketbaseService);
  private readonly caseApiService = inject(CaseApiService);
  private readonly customToastrService = inject(CustomToastrService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly caseDataService = inject(CaseDataService);
  private readonly activatedRoute = inject(ActivatedRoute);
  public readonly spinnerService = inject(SpinnerService);

  readonly spinnerName = 'create-case';

  focusDataNotProcessed = false;

  CASE_ID: string = '';
  edit_route: string = '';
  processedID: string = '';

  focus_data0: Section[][] = [];
  focus_data1: Section[][] = [];
  focus_data2: Section[][] = [];
  focus_data3: Section[][] = [];
  focus_data4: Section[][] = [];

  isCreated = false;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    public authService: AuthService
  ) { }

  async ngOnInit() {
    this.initCaseSpinner(this.activatedRoute.snapshot.params?.['id']);

    this.route.params.subscribe(async params => {

      this.CASE_ID = params['id'];
      if (params['id']) {
        this.isCreated = true;
        const _case = await this.loadFullCase(params['id']);
        if (!_case) {
          // handle error or redirect
          return;
        }
        // If case is new (0), processing, or pending (1), subscribe for updates
        const caseStatus = Number(_case.status);
        if (caseStatus < 2 && caseStatus !== 99) {
          await this.subscribeToCase(this.CASE_ID);
        }

        // NOTE: Auto-processing logic removed.
        // CreateCaseEditorComponent now handles the complete creation flow.
        // This component is for ADMINS ONLY to edit config and retrigger processing.
        if (!this.authService.isAdmin()) {
          console.log('⚠️ Non-admin user on CreateCaseComponent - this should not happen');
          // Redirect non-admins to the editor
          this.router.navigate(['/create-case-editor', this.CASE_ID]);
          return;
        }
      } else {
        // Creating new
      }
    });
  }

  ngOnDestroy() {
    this.spinnerService.stopSpinner(this.spinnerName);
    // Clean up automatic processing
    this.cleanupAutomaticProcessing();
  }

  private initCaseSpinner(id: string) {
    const request = this.caseDataService.getCaseRequestById(id);

    if (request) {
      this.spinnerService.startSpinner(this.spinnerName);
    } else {
      this.spinnerService.stopSpinner(this.spinnerName);
    }
  }

  slideIn = false;
  processedMstrlsng = false;

  slideInBody() {
    this.slideIn = !this.slideIn;
  }
  removeFile(fileInput: HTMLInputElement): void {
    fileInput.value = '';
  }

  processedMstrlsngShow() {
    this.processedMstrlsng = !this.processedMstrlsng;
  }

  hoveredChunkIndex = 0;
  hoveredFocusIndex = -1;

  chunkClicked = false;
  focusClicked = false;

  tabNames = ['Rechtsfragen', 'Anspruchsgrundlagen', 'Vorausetzungen', 'Ergebnis', 'Votum'];
  tabName = this.tabNames[0];
  tabNr = 0;
  letters = 'abcdefghijklmnopqrstuvwxyz'.split('');

  embeddingModelApi = 'voyage';
  embeddingModel = 'text-embedding-3-large';
  modelApi = 'anthropic';
  model = 'gpt-5.2';

  name = '';
  description = '';
  category = '';
  situation = '';
  sampleSolution = '';
  tags: string[] = [];
  selectedImageFile: File | null = null;
  imagePreviewUrl: string | null = null;
  originalImage: string | null = null;
  private originalImageBlob: Blob | null = null;
  private originalImageBlobPromise: Promise<void> | null = null;

  // ============================
  // TAB 0
  // ============================
  prePrompt = '';
  contextPrompt = '';
  finalPrompt = '';

  deviationThreshold = 0.45;
  indexThreshold = 15;
  simThreshold = 0.4;
  temperature = 0.0;
  maxOutputTokens = 4096;

  rows = [{ letter: 'a', value: '' }];
  focuses: { value: string; }[] = [];
  schwerpunktPrompts: { value: string; }[] = [];


  // ============================
  // TAB 1
  // ============================
  prePrompt1 = '';
  contextPrompt1 = '';
  finalPrompt1 = '';

  deviationThreshold1 = 0.45;
  indexThreshold1 = 15;
  simThreshold1 = 0.4;
  temperature1 = 0.0;
  maxOutputTokens1 = 4096;

  rows1 = [{ letter: 'a', value: '' }];
  focuses1: { value: string; }[] = [];
  schwerpunktPrompts1: { value: string; }[] = [];

  // ============================
  // TAB 2
  // ============================
  prePrompt2 = '';
  contextPrompt2 = '';
  finalPrompt2 = '';

  deviationThreshold2 = 0.45;
  indexThreshold2 = 15;
  simThreshold2 = 0.4;
  temperature2 = 0.0;
  maxOutputTokens2 = 4096;

  rows2 = [{ letter: 'a', value: '' }];
  focuses2: { value: string; }[] = [];
  schwerpunktPrompts2: { value: string; }[] = [];


  // ============================
  // TAB 3
  // ============================
  prePrompt3 = '';
  contextPrompt3 = '';
  finalPrompt3 = '';

  deviationThreshold3 = 0.45;
  indexThreshold3 = 15;
  simThreshold3 = 0.4;
  temperature3 = 0.0;
  maxOutputTokens3 = 4096;

  rows3 = [{ letter: 'a', value: '' }];
  focuses3: { value: string; }[] = [];
  schwerpunktPrompts3: { value: string; }[] = [];


  // ============================
  // TAB 4 (SPECIAL)
  // ============================
  contextPrompt4 = '';
  inhaltPrompt4 = '';
  temperature_inhalt = 0.0;
  max_output_tokens_inhalt = 4096;
  erwHorPrompt4 = '';
  temperature_erwHor = 0.0;
  max_output_tokens_erwHor = 4096;
  ausblickPrompt4 = '';
  temperature_ausblick = 0.0;
  max_output_tokens_ausblick = 4096;
  notePrompt4 = '';
  temperature_note = 0.0;
  max_output_tokens_note = 4096;
  select_grading_prompt = false;

  processed_mstrlsg: Processed_musterlsg[] = [];

  // ============================
  // Tags Management
  // ============================
  getAvailableTags(): readonly string[] {
    if (!this.category) return [];
    return LEGAL_TAGS_BY_CATEGORY[this.category as LegalCategory] || [];
  }

  toggleTag(tag: string): void {
    const index = this.tags.indexOf(tag);

    if (index > -1) {
      // Remove tag
      this.tags = this.tags.filter(t => t !== tag);
    } else {
      // Add tag (max 10 tags)
      if (this.tags.length < 10) {
        this.tags = [...this.tags, tag];
      }
    }
  }

  isTagSelected(tag: string): boolean {
    return this.tags.includes(tag);
  }

  // ============================
  // Hover & Focus logic
  // ============================
  onHoverFocusStart(index: number) {
    if (this.focusClicked) return;
    this.hoveredFocusIndex = index;
  }

  onHoverFocusEnd(index: number) {
    if (this.focusClicked) return;
    this.hoveredFocusIndex = -1;
  }

  lastElem?: any;

  onClickFocus(index: number, elem: any) {
    if (this.hoveredFocusIndex !== index) {
      if (!this.lastElem) return;
      this.lastElem.classList.remove('hoverable-focus-hovered');
    }
    if (this.hoveredFocusIndex === index) {
      this.focusClicked = !this.focusClicked;
    }
    this.hoveredFocusIndex = index;
    if (this.focusClicked) {
      elem.classList.add('hoverable-focus-hovered');
      this.lastElem = elem;
    } else {
      elem.classList.remove('hoverable-focus-hovered');
    }
  }

  onHoverChunkStart(index: number) {
    this.hoveredChunkIndex = index;
  }

  onHoverChunkEnd(index: number) {
    this.hoveredChunkIndex = 0;
  }

  // ============================
  // Convert arrays
  // ============================
  convertToStringArray(focuses: { value: string }[]): string[] {
    return focuses.map(focus => focus.value);
  }

  convertToFocusesArray(strings: string[]): { value: string }[] {
    return strings.map(str => ({ value: str }));
  }

  // ============================
  // Row & Focus add/remove
  // ============================
  addRow() {
    const availableLetter = this.letters.find(
      (letter) => !this.rows.some((row) => row.letter === letter)
    );
    if (availableLetter) {
      this.rows.push({ letter: availableLetter, value: '' });
    } else {
      alert('Max. Anzahl erreicht !');
    }
  }
  removeRow(index: number) {
    if (this.rows.length < 2) return;
    this.rows.splice(index, 1);
  }

  addRow1() {
    const availableLetter = this.letters.find(
      (letter) => !this.rows1.some((row) => row.letter === letter)
    );
    if (availableLetter) {
      this.rows1.push({ letter: availableLetter, value: '' });
    } else {
      alert('Max. Anzahl erreicht!');
    }
  }
  removeRow1(index: number) {
    if (this.rows1.length < 2) return;
    this.rows1.splice(index, 1);
  }

  addRow2() {
    const availableLetter = this.letters.find(
      (letter) => !this.rows2.some((row) => row.letter === letter)
    );
    if (availableLetter) {
      this.rows2.push({ letter: availableLetter, value: '' });
    } else {
      alert('Max. Anzahl erreicht!');
    }
  }
  removeRow2(index: number) {
    if (this.rows2.length < 2) return;
    this.rows2.splice(index, 1);
  }

  addRow3() {
    const availableLetter = this.letters.find(
      (letter) => !this.rows3.some((row) => row.letter === letter)
    );
    if (availableLetter) {
      this.rows3.push({ letter: availableLetter, value: '' });
    } else {
      alert('Max. Anzahl erreicht!');
    }
  }
  removeRow3(index: number) {
    if (this.rows3.length < 2) return;
    this.rows3.splice(index, 1);
  }

  addFocus() {
    this.focuses.push({ value: '' });
    this.schwerpunktPrompts.push({ value: '' });
  }
  removeFocus(index: number) {
    if (this.focuses.length < 2) return;
    this.focuses.splice(index, 1);
    this.schwerpunktPrompts.splice(index, 1);

  }

  addFocus1() {
    this.focuses1.push({ value: '' });
    this.schwerpunktPrompts1.push({ value: '' });
  }
  removeFocus1(index: number) {
    if (this.focuses1.length < 2) return;
    this.focuses1.splice(index, 1);
    this.schwerpunktPrompts1.splice(index, 1);

  }

  addFocus2() {
    this.focuses2.push({ value: '' });
    this.schwerpunktPrompts2.push({ value: '' });
  }
  removeFocus2(index: number) {
    if (this.focuses2.length < 2) return;
    this.focuses2.splice(index, 1);
    this.schwerpunktPrompts2.splice(index, 1);

  }

  addFocus3() {
    this.focuses3.push({ value: '' });
    this.schwerpunktPrompts3.push({ value: '' });
  }
  removeFocus3(index: number) {
    if (this.focuses3.length < 2) return;
    this.focuses3.splice(index, 1);
    this.schwerpunktPrompts3.splice(index, 1);

  }

  // ============================
  // getAvailableLetters
  // ============================
  getAvailableLetters(rowIndex: number) {
    // Example: This checks which letters are already taken in `rows`.
    // If you want a similar function for rows1, rows2, rows3,
    // you'd replicate or modify this one.
    return this.letters.filter(
      (letter) =>
        !this.rows.some(
          (row, idx) => row.letter === letter && idx !== rowIndex
        )
    );
  }

  changeTab(newTab: number) {
    if (this.tabNr === newTab) return;
    const newTabElem = document.getElementById('tab' + newTab);
    const oldTabElem = document.getElementById('tab' + this.tabNr);
    this.tabName = this.tabNames[newTab];
    newTabElem?.classList.add('active');
    oldTabElem?.classList.remove('active');
    this.tabNr = newTab;
  }

  private createConfTab(
    embeddingModelApi: string,
    embeddingModel: string,
    modelApi: string,
    model: string,
    deviationThreshold: number,
    indexThreshold: number,
    simThreshold: number,
    temperature: number,
    maxOutputTokens: number,
    _focuses: { value: string }[],
    _schwerpunktPrompts: { value: string }[],
    _answer_parser: Record<string, string>,
    prePrompt: string,
    contextPrompt: string,
    finalPrompt: string
  ): ConfTab {
    return {
      config: {
        embedding_model_api: embeddingModelApi,
        embedding_model: embeddingModel,
        model_api: modelApi,
        model: model,
        deviation_threshold: deviationThreshold,
        index_threshold: indexThreshold,
        sim_threshold: simThreshold,
        temperature: temperature,
        max_output_tokens: maxOutputTokens,
        schwerpunkte: this.convertToStringArray(_focuses),
        schwerpunkt_prompts: this.convertToStringArray(_schwerpunktPrompts),
        answer_parser: _answer_parser,
      },
      pre_prompt: prePrompt,
      context_prompt: contextPrompt,
      final_prompt: finalPrompt,
    };
  }


  async returnToCreateCase() {
    // Wait for save to complete, then navigate
    await this.create(2, false); // false = don't show success toast
    this.router.navigate([`/create-case-editor/${this.CASE_ID}`]);
  }

  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        this.customToastrService.showError('Please select a valid image file');
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        this.customToastrService.showError('Image file must be smaller than 5MB');
        return;
      }

      this.selectedImageFile = file;

      // Create preview URL
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreviewUrl = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage(): void {
    this.selectedImageFile = null;
    this.imagePreviewUrl = null;
    // Reset file input
    const fileInput = document.getElementById('imageInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  triggerFileInput(): void {
    const fileInput = document.getElementById('imageInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  async create(type: number, showSuccessMessage: boolean = true, status: string = '-1'): Promise<void> {
    // 🔥 BUILD CASE DATA 
    const conf_tab0 = this.createConfTab(
      this.embeddingModelApi,
      this.embeddingModel,
      this.modelApi,
      this.model,
      this.deviationThreshold,
      this.indexThreshold,
      this.simThreshold,
      this.temperature,
      this.maxOutputTokens,
      this.focuses,
      this.schwerpunktPrompts,
      this.rows.reduce((acc, item) => {
        acc[item.letter] = item.value;
        return acc;
      }, {} as Record<string, string>),
      this.prePrompt,
      this.contextPrompt,
      this.finalPrompt
    );

    const conf_tab1 = this.createConfTab(
      this.embeddingModelApi,
      this.embeddingModel,
      this.modelApi,
      this.model,
      this.deviationThreshold1,
      this.indexThreshold1,
      this.simThreshold1,
      this.temperature1,
      this.maxOutputTokens1,
      this.focuses1,
      this.schwerpunktPrompts1,
      this.rows1.reduce((acc, item) => {
        acc[item.letter] = item.value;
        return acc;
      }, {} as Record<string, string>),
      this.prePrompt1,
      this.contextPrompt1,
      this.finalPrompt1
    );

    const conf_tab2 = this.createConfTab(
      this.embeddingModelApi,
      this.embeddingModel,
      this.modelApi,
      this.model,
      this.deviationThreshold2,
      this.indexThreshold2,
      this.simThreshold2,
      this.temperature2,
      this.maxOutputTokens2,
      this.focuses2,
      this.schwerpunktPrompts2,
      this.rows2.reduce((acc, item) => {
        acc[item.letter] = item.value;
        return acc;
      }, {} as Record<string, string>),
      this.prePrompt2,
      this.contextPrompt2,
      this.finalPrompt2
    );

    const conf_tab3 = this.createConfTab(
      this.embeddingModelApi,
      this.embeddingModel,
      this.modelApi,
      this.model,
      this.deviationThreshold3,
      this.indexThreshold3,
      this.simThreshold3,
      this.temperature3,
      this.maxOutputTokens3,
      this.focuses3,
      this.schwerpunktPrompts3,
      this.rows3.reduce((acc, item) => {
        acc[item.letter] = item.value;
        return acc;
      }, {} as Record<string, string>),
      this.prePrompt3,
      this.contextPrompt3,
      this.finalPrompt3
    );

    // Build tab 4 with only the special fields
    const conf_tab4 = {
      context_prompt: this.contextPrompt4,
      inhalt_prompt: this.inhaltPrompt4,
      temperature_inhalt: this.temperature_inhalt,
      max_output_tokens_inhalt: this.max_output_tokens_inhalt,
      erw_hor_prompt: this.erwHorPrompt4,
      temperature_erwHor: this.temperature_erwHor,
      max_output_tokens_erwHor: this.max_output_tokens_erwHor,
      ausblick_prompt: this.ausblickPrompt4,
      temperature_ausblick: this.temperature_ausblick,
      max_output_tokens_ausblick: this.max_output_tokens_ausblick,
      note_prompt: this.notePrompt4,
      temperature_note: this.temperature_note,
      max_output_tokens_note: this.max_output_tokens_note,
      select_grading_prompt: this.select_grading_prompt
    };

    const createdCase: Created_Case = {
      name: this.name,
      description: this.description,
      category: this.category,
      situation: this.situation,
      processed_id: this.processedID,
      tags: this.tags, // ← PRESERVE tags from loaded case
      processed: {
        name: this.name,
        ss_processed_overview: undefined,
        description: this.description,
        sample_solution: this.sampleSolution,

        conf_tab0,
        conf_tab1,
        conf_tab2,
        conf_tab3,
        conf_tab4
      }
    };

    const excludedKeys = new Set([
      'config',
      'processed_id',
      'ss_processed_overview',
      'final_prompt',
      'erw_hor_prompt',
      'ausblick_prompt',
      'note_prompt'
    ]);

    function findEmptyFields(obj: any, path = ''): string[] {
      const emptyPaths: string[] = [];

      for (const key of Object.keys(obj)) {
        if (excludedKeys.has(key)) continue;
        const val = obj[key];
        const current = path ? `${path}.${key}` : key;

        if (val === null || val === undefined) {
          emptyPaths.push(current);
        } else if (typeof val === 'string') {
          if (!val.trim()) emptyPaths.push(current);
        } else if (typeof val === 'object') {
          emptyPaths.push(...findEmptyFields(val, current));
        }
      }

      return emptyPaths;
    }

    if (type === 1) {
      const missing = findEmptyFields(createdCase);
      if (missing.length) {
        this.customToastrService.showError("Please fill all fields");
        return;
      }

      this.caseApiService
        .createCase(createdCase, {
          showSpinner: true,
          spinnerName: this.spinnerName,
          showSuccessMessage: true
        })
        .pipe(take(1))
        .subscribe(async caseId => {
          try {
            // Upload image and tags if needed
            const updateData: any = {};
            if (this.selectedImageFile) {
              updateData.img = this.selectedImageFile;
            }
            if (this.tags && this.tags.length > 0) {
              updateData.tags = this.tags;
            }

            if (Object.keys(updateData).length > 0) {
              await this.pocketbaseService.getPocketBase()
                .collection('cases')
                .update(caseId, updateData);
            }

            this.router.navigate(['c', caseId]);
          } catch (error) {
            console.error('Error uploading image:', error);
            this.customToastrService.showError('Case created but failed to upload image');
            this.router.navigate(['c', caseId]);
          }
        });
      return;
    }


    if (type === 2) {
      return new Promise<void>((resolve) => {
        const caseSubscription = this.caseApiService
          .updateCase(this.CASE_ID, createdCase, {
            showSpinner: true,
            showSuccessMessage: showSuccessMessage,
            spinnerName: this.spinnerName,
            status: status
          })
          .pipe(take(1))
          .subscribe({
            complete: async () => {
              try {
                // Handle image upload/update for existing cases
                let updateData: any = {};

                if (this.selectedImageFile) {
                  // User selected a new image - validate and upload it
                  if (this.selectedImageFile.size > 5 * 1024 * 1024) {
                    throw new Error('Image file must be smaller than 5MB');
                  }
                  if (!this.selectedImageFile.type.startsWith('image/')) {
                    throw new Error('Please select a valid image file');
                  }
                  updateData.img = this.selectedImageFile;
                } else if (!this.imagePreviewUrl && this.originalImage) {
                  // User removed the existing image - set img to null
                  updateData.img = null;
                }

                // DON'T update tags here - they should only be updated in create-case-editor
                // Stage 5 (Aktualisieren) is for configuration updates, not metadata
                // updateData.tags = this.tags || []; // ← REMOVED! This was overwriting tags with empty array!

                console.log('🏷️ [STAGE 5: AKTUALISIEREN - AFTER UPDATE] Updating tags: SKIPPED (preserving existing tags)');
                console.log('🖼️ [STAGE 5: AKTUALISIEREN - AFTER UPDATE] Updating image:', !!updateData.img);

                // Only update if we have data to update.
                const hasActualData = Object.keys(updateData).length > 0;
                if (hasActualData) {
                  await this.pocketbaseService.getPocketBase()
                    .collection('cases')
                    .update(this.CASE_ID, updateData);

                  console.log('✅ [STAGE 5: AKTUALISIEREN - AFTER UPDATE] Tags and image updated successfully');
                }

                this.caseDataService.removeCaseRequest(this.CASE_ID);
                resolve();
              } catch (error) {
                console.error('Error updating image:', error);
                const errorMessage = error instanceof Error ? error.message : 'Failed to update image, but case was saved';
                this.customToastrService.showError(errorMessage);

                this.caseDataService.removeCaseRequest(this.CASE_ID);
                resolve();
              }
            },
            error: async () => {
              try {
                this.caseDataService.removeCaseRequest(this.CASE_ID);
                resolve();
              } catch (flagError) {
                this.caseDataService.removeCaseRequest(this.CASE_ID);
                resolve();
              }
            }
          });

        this.caseDataService.addCaseRequest({ id: this.CASE_ID, subscription: caseSubscription, spinnerName: this.spinnerName });
      });
    }
  }

  parseCase(_case: Created_Case) {
    console.log('🔄 [STAGE 4: LOAD IN CREATE-CASE] parseCase called');
    console.log('🔍 [STAGE 4: LOAD IN CREATE-CASE] Case data:', {
      id: _case.id,
      tags: _case.tags,
      img: _case.img,
      hasImage: !!_case.img
    });

    // Basic validation
    if (!_case.processed?.id) {
      console.error("Processed data or ID is missing.");
      return;
    }

    // Always set basic fields
    this.setBasicFields(_case);

    // Always load common data
    this.loadCommonData(_case);

    // Check if we have saved configuration (conf_tab fields)
    const hasSavedConfig = _case.processed?.conf_tab0 || _case.processed?.conf_tab1 ||
      _case.processed?.conf_tab2 || _case.processed?.conf_tab3 ||
      _case.processed?.conf_tab4;

    if (hasSavedConfig) {
      // Load from saved configuration (subsequent visits)
      this.loadFromSavedConfiguration(_case);
    } else {
      // Load from initial generation (first time - map_chunks_focus_points)
      this.loadFromInitialGeneration(_case);
    }
  }

  private setBasicFields(_case: Created_Case) {
    this.processedID = _case.processed!.id || '';
    this.name = _case.name;
    this.description = _case.description;
    this.category = _case.category;
    this.situation = _case.situation;
    this.tags = _case.tags || [];
    console.log('🏷️ [STAGE 4: LOAD IN CREATE-CASE] Tags loaded into component:', this.tags);

    // Load existing image if available
    if (_case.img) {
      this.originalImage = _case.img;
      this.imagePreviewUrl = this.pocketbaseService.getPocketBase().files.getURL(_case, _case.img);
      console.log('🖼️ [STAGE 4: LOAD IN CREATE-CASE] originalImage set to:', this.originalImage);
      this.cacheOriginalImageBlob(_case);
    } else {
      this.originalImage = null;
      this.originalImageBlob = null;
    }
  }

  private cacheOriginalImageBlob(caseRecord: Created_Case): void {
    console.log('📥 [IMAGE CACHE] Starting to cache original image blob...');
    console.log('  - caseRecord.img:', caseRecord.img);
    console.log('  - current preview URL:', this.imagePreviewUrl);

    if (!caseRecord.img) {
      console.log('⏭️ [IMAGE CACHE] No image filename present on case, skipping cache');
      this.originalImageBlob = null;
      return;
    }

    const cachedKey = `imageBlob_${this.CASE_ID}`;
    const cachedData = sessionStorage.getItem(cachedKey);
    if (cachedData) {
      console.log('♻️ [IMAGE CACHE] Found cached blob in sessionStorage, restoring...');
      try {
        const { base64, type } = JSON.parse(cachedData);
        const dataUrl = `data:${type};base64,${base64}`;

        if (!this.originalImageBlobPromise) {
          this.originalImageBlobPromise = fetch(dataUrl)
            .then(res => {
              if (!res.ok) {
                throw new Error(`Failed to convert base64 to blob (status ${res.status})`);
              }
              return res.blob();
            })
            .then(blob => {
              this.originalImageBlob = blob;
              console.log('✅ [IMAGE CACHE] Restored blob from sessionStorage:', blob.size, 'bytes');
            })
            .catch(error => {
              console.error('❌ [IMAGE CACHE] Failed to restore from sessionStorage:', error);
              this.originalImageBlob = null;
            })
            .finally(() => {
              this.originalImageBlobPromise = null;
            });
        }
        return;
      } catch (error) {
        console.error('❌ [IMAGE CACHE] Failed to parse cached blob data:', error);
        sessionStorage.removeItem(cachedKey);
      }
    }

    if (this.originalImageBlobPromise) {
      console.log('⏭️ [IMAGE CACHE] Cache already in progress, skipping');
      return;
    }

    const url = this.pocketbaseService.getPocketBase().files.getURL(caseRecord, caseRecord.img);
    if (!url) {
      console.error('❌ [IMAGE CACHE] Could not generate download URL for original image');
      return;
    }

    if (!this.imagePreviewUrl) {
      this.imagePreviewUrl = url;
    }

    console.log('🌐 [IMAGE CACHE] Fetching image from URL:', url);

    this.originalImageBlobPromise = fetch(url, { credentials: 'include' })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch original image (status ${response.status})`);
        }
        const blob = await response.blob();
        this.originalImageBlob = blob;
        console.log('✅ [IMAGE CACHE] Successfully cached image blob:', blob.size, 'bytes, type:', blob.type);

        const reader = new FileReader();
        reader.onloadend = () => {
          const result = reader.result as string | null;
          if (!result) {
            console.error('❌ [IMAGE CACHE] Failed to convert blob to base64');
            return;
          }
          const base64 = result.split(',')[1];
          sessionStorage.setItem(cachedKey, JSON.stringify({ base64, type: blob.type || 'image/jpeg' }));
          console.log('💾 [IMAGE CACHE] Saved blob to sessionStorage for cross-reload persistence');
        };
        reader.readAsDataURL(blob);
      })
      .catch((error) => {
        console.error('❌ [IMAGE CACHE] Failed to cache original image blob:', error);
        this.originalImageBlob = null;
      })
      .finally(() => {
        this.originalImageBlobPromise = null;
      });
  }

  private loadCommonData(_case: Created_Case) {
    const processed = _case.processed!;

    // Focus data check
    this.focusDataNotProcessed = !processed.focus_data0 && !processed.focus_data1 &&
      !processed.focus_data2 && !processed.focus_data3 && !processed.focus_data4;

    // Load focus data arrays
    this.focus_data0 = processed.focus_data0 || [];
    this.focus_data1 = processed.focus_data1 || [];
    this.focus_data2 = processed.focus_data2 || [];
    this.focus_data3 = processed.focus_data3 || [];
    this.focus_data4 = processed.focus_data4 || [];

    // Load other common data
    this.processed_mstrlsg = processed.processed_mstrlsg || [];
    if (processed.sample_solution) {
      this.sampleSolution = processed.sample_solution;
    }
  }

  private loadFromInitialGeneration(_case: Created_Case) {
    // Clear all arrays
    this.clearAllArrays();

    // Load focus points from map_chunks_focus_points
    const mapChunks = _case.processed?.['map_chunks_focus_points'];
    if (mapChunks?.focusPoints) {
      mapChunks.focusPoints.forEach((focusPoint: any) => {
        this.addFocusPointToTab(focusPoint);
      });
    }
  }

  private loadFromSavedConfiguration(_case: Created_Case) {
    const processed = _case.processed!;

    // Load model configuration
    if (processed.conf_tab0) {
      this.embeddingModelApi = processed.conf_tab0.config.embedding_model_api;
      this.embeddingModel = processed.conf_tab0.config.embedding_model;
      this.modelApi = processed.conf_tab0.config.model_api;
      this.model = processed.conf_tab0.config.model;
    }

    // Load each tab
    this.loadTab(0, processed.conf_tab0);
    this.loadTab(1, processed.conf_tab1);
    this.loadTab(2, processed.conf_tab2);
    this.loadTab(3, processed.conf_tab3);
    this.loadTab4(processed.conf_tab4);
  }

  private overrideFocusPoints(_case: Created_Case) {
    // Clear only focus arrays (keep schwerpunkt prompts)
    this.focuses.length = 0;
    this.focuses1.length = 0;
    this.focuses2.length = 0;
    this.focuses3.length = 0;

    //  Check if map_chunks_focus_points exists and has focusPoints
    const mapChunks = _case.processed?.['map_chunks_focus_points'];
    if (mapChunks?.focusPoints) {
      mapChunks.focusPoints.forEach((focusPoint: any) => {
        // Support both new German enum and legacy English string
        if (focusPoint.tabName === CreateCaseEditorTabs.Rechtsfragen || focusPoint.tabName === 'judicial-matters') {
          this.focuses.push({ value: focusPoint.fp_text! });
        }
        if (focusPoint.tabName === CreateCaseEditorTabs.Anspruchsgrundlagen || focusPoint.tabName === 'basis-of-claim') {
          this.focuses1.push({ value: focusPoint.fp_text! });
        }
        if (focusPoint.tabName === CreateCaseEditorTabs.Voraussetzungen || focusPoint.tabName === 'pre-requisites') {
          this.focuses2.push({ value: focusPoint.fp_text! });
        }
        if (focusPoint.tabName === CreateCaseEditorTabs.Ergebnis || focusPoint.tabName === 'result') {
          this.focuses3.push({ value: focusPoint.fp_text! });
        }
      });
    }
  }

  private clearAllArrays() {
    this.focuses.length = 0;
    this.focuses1.length = 0;
    this.focuses2.length = 0;
    this.focuses3.length = 0;
    this.schwerpunktPrompts.length = 0;
    this.schwerpunktPrompts1.length = 0;
    this.schwerpunktPrompts2.length = 0;
    this.schwerpunktPrompts3.length = 0;
  }

  private addFocusPointToTab(focusPoint: any) {
    // Support both new German enum and legacy English string
    if (focusPoint.tabName === CreateCaseEditorTabs.Rechtsfragen || focusPoint.tabName === 'judicial-matters') {
      this.focuses.push({ value: focusPoint.fp_text! });
      this.schwerpunktPrompts.push({ value: '' });
    }
    if (focusPoint.tabName === CreateCaseEditorTabs.Anspruchsgrundlagen || focusPoint.tabName === 'basis-of-claim') {
      this.focuses1.push({ value: focusPoint.fp_text! });
      this.schwerpunktPrompts1.push({ value: '' });
    }
    if (focusPoint.tabName === CreateCaseEditorTabs.Voraussetzungen || focusPoint.tabName === 'pre-requisites') {
      this.focuses2.push({ value: focusPoint.fp_text! });
      this.schwerpunktPrompts2.push({ value: '' });
    }
    if (focusPoint.tabName === CreateCaseEditorTabs.Ergebnis || focusPoint.tabName === 'result') {
      this.focuses3.push({ value: focusPoint.fp_text! });
      this.schwerpunktPrompts3.push({ value: '' });
    }
  }

  private loadTab(tabIndex: number, confTab: any) {
    if (!confTab) return;

    //  Direct assignment based on tabIndex
    switch (tabIndex) {
      case 0:
        this.prePrompt = confTab.pre_prompt || '';
        this.contextPrompt = confTab.context_prompt || '';
        this.finalPrompt = confTab.final_prompt || '';
        this.deviationThreshold = confTab.config?.deviation_threshold ?? 0.45;
        this.indexThreshold = confTab.config?.index_threshold ?? 15;
        this.simThreshold = confTab.config?.sim_threshold ?? 0.4;
        this.temperature = confTab.config?.temperature !== undefined ? confTab.config.temperature : 0.0;
        this.maxOutputTokens = confTab.config?.max_output_tokens ?? 4096;
        this.loadTabArrays(confTab, this.rows, this.focuses, this.schwerpunktPrompts);
        break;
      case 1:
        this.prePrompt1 = confTab.pre_prompt || '';
        this.contextPrompt1 = confTab.context_prompt || '';
        this.finalPrompt1 = confTab.final_prompt || '';
        this.deviationThreshold1 = confTab.config?.deviation_threshold ?? 0.45;
        this.indexThreshold1 = confTab.config?.index_threshold ?? 15;
        this.simThreshold1 = confTab.config?.sim_threshold ?? 0.4;
        this.temperature1 = confTab.config?.temperature !== undefined ? confTab.config.temperature : 0.0;
        this.maxOutputTokens1 = confTab.config?.max_output_tokens ?? 4096;
        this.loadTabArrays(confTab, this.rows1, this.focuses1, this.schwerpunktPrompts1);
        break;
      case 2:
        this.prePrompt2 = confTab.pre_prompt || '';
        this.contextPrompt2 = confTab.context_prompt || '';
        this.finalPrompt2 = confTab.final_prompt || '';
        this.deviationThreshold2 = confTab.config?.deviation_threshold ?? 0.45;
        this.indexThreshold2 = confTab.config?.index_threshold ?? 15;
        this.simThreshold2 = confTab.config?.sim_threshold ?? 0.4;
        this.temperature2 = confTab.config?.temperature !== undefined ? confTab.config.temperature : 0.0;
        this.maxOutputTokens2 = confTab.config?.max_output_tokens ?? 4096;
        this.loadTabArrays(confTab, this.rows2, this.focuses2, this.schwerpunktPrompts2);
        break;
      case 3:
        this.prePrompt3 = confTab.pre_prompt || '';
        this.contextPrompt3 = confTab.context_prompt || '';
        this.finalPrompt3 = confTab.final_prompt || '';
        this.deviationThreshold3 = confTab.config?.deviation_threshold ?? 0.45;
        this.indexThreshold3 = confTab.config?.index_threshold ?? 15;
        this.simThreshold3 = confTab.config?.sim_threshold ?? 0.4;
        this.temperature3 = confTab.config?.temperature !== undefined ? confTab.config.temperature : 0.0;
        this.maxOutputTokens3 = confTab.config?.max_output_tokens ?? 4096;
        this.loadTabArrays(confTab, this.rows3, this.focuses3, this.schwerpunktPrompts3);
        break;
    }
  }

  private loadTabArrays(
    confTab: any,
    rows: { letter: string, value: string }[],
    focuses: { value: string }[],
    schwerpunktPrompts: { value: string }[]
  ) {
    // Load answer parsers
    const parsers = confTab.config?.answer_parser || {};
    rows.length = 0;
    for (const parser in parsers) {
      rows.push({ letter: parser, value: parsers[parser] });
    }

    // Load focus points
    const focusesData = confTab.config?.schwerpunkte || [];
    focuses.length = 0;
    for (const focus of focusesData) {
      focuses.push({ value: focus });
    }

    // Load schwerpunkt prompts
    const schwerpunktPromptsData = confTab.config?.schwerpunkt_prompts || [];
    schwerpunktPrompts.length = 0;
    for (let i = 0; i < focusesData.length; i++) {
      schwerpunktPrompts.push({ value: schwerpunktPromptsData[i] || '' });
    }
  }

  private getTabData(tabIndex: number) {
    switch (tabIndex) {
      case 0: return {
        prePrompt: this.prePrompt, contextPrompt: this.contextPrompt, finalPrompt: this.finalPrompt,
        deviationThreshold: this.deviationThreshold, indexThreshold: this.indexThreshold, simThreshold: this.simThreshold,
        rows: this.rows, focuses: this.focuses, schwerpunktPrompts: this.schwerpunktPrompts
      };
      case 1: return {
        prePrompt: this.prePrompt1, contextPrompt: this.contextPrompt1, finalPrompt: this.finalPrompt1,
        deviationThreshold: this.deviationThreshold1, indexThreshold: this.indexThreshold1, simThreshold: this.simThreshold1,
        rows: this.rows1, focuses: this.focuses1, schwerpunktPrompts: this.schwerpunktPrompts1
      };
      case 2: return {
        prePrompt: this.prePrompt2, contextPrompt: this.contextPrompt2, finalPrompt: this.finalPrompt2,
        deviationThreshold: this.deviationThreshold2, indexThreshold: this.indexThreshold2, simThreshold: this.simThreshold2,
        rows: this.rows2, focuses: this.focuses2, schwerpunktPrompts: this.schwerpunktPrompts2
      };
      case 3: return {
        prePrompt: this.prePrompt3, contextPrompt: this.contextPrompt3, finalPrompt: this.finalPrompt3,
        deviationThreshold: this.deviationThreshold3, indexThreshold: this.indexThreshold3, simThreshold: this.simThreshold3,
        rows: this.rows3, focuses: this.focuses3, schwerpunktPrompts: this.schwerpunktPrompts3
      };
      default: return null;
    }
  }

  private loadTab4(confTab4: any) {
    if (!confTab4) return;

    this.contextPrompt4 = confTab4.context_prompt || '';
    this.inhaltPrompt4 = confTab4.inhalt_prompt || '';
    this.temperature_inhalt = confTab4.temperature_inhalt !== undefined ? confTab4.temperature_inhalt : 0.0;
    this.max_output_tokens_inhalt = confTab4.max_output_tokens_inhalt ?? 4096;
    this.erwHorPrompt4 = confTab4.erw_hor_prompt || '';
    this.temperature_erwHor = confTab4.temperature_erwHor !== undefined ? confTab4.temperature_erwHor : 0.0;
    this.max_output_tokens_erwHor = confTab4.max_output_tokens_erwHor ?? 4096;
    this.ausblickPrompt4 = confTab4.ausblick_prompt || '';
    this.temperature_ausblick = confTab4.temperature_ausblick !== undefined ? confTab4.temperature_ausblick : 0.0;
    this.max_output_tokens_ausblick = confTab4.max_output_tokens_ausblick ?? 4096;
    this.notePrompt4 = confTab4.note_prompt || '';
    this.temperature_note = confTab4.temperature_note !== undefined ? confTab4.temperature_note : 0.0;
    this.max_output_tokens_note = confTab4.max_output_tokens_note ?? 4096;
    this.select_grading_prompt = confTab4.select_grading_prompt || false;
  }

  async downloadOverview() {
    const anchor = document.createElement('a');
    anchor.href = await this.dataService.loadSolutionCSV(this.processedID);
    anchor.download = this.CASE_ID + '_overview.csv';
    anchor.target = '_blank';
    anchor.click();
    anchor.remove();
  }

  async subscribeToCase(caseID: string) {
    await this.pocketbaseService.getPocketBase().collection('cases').subscribe(
      caseID,
      async (e) => {
        if (e.action == 'update') {
          console.log('🔄 [SUBSCRIBE] Case update received, status:', e.record['status'], 'img:', e.record['img']);
        }

        // Handle processing error (status 99) - status may be string or number
        const status = Number(e.record['status']);
        if (status === 99) {
          console.error('❌ [SUBSCRIBE] Processing failed (status 99)');
          this.customToastrService.showError(
            'Die PDF-Datei konnte nicht verarbeitet werden. ' +
            'Bitte stellen Sie sicher, dass es sich um eine gültige PDF-Datei mit extrahierbarem Text handelt.'
          );
          await this.pocketbaseService.getPocketBase().collection('cases').unsubscribe(caseID);
          this.spinnerService.stopSpinner(this.spinnerName);
          return;
        }

        if (status > 0) {
          console.log('✅ [SUBSCRIBE] Processing complete (status > 0), checking image...');
          await this.restoreImageIfMissing(e.record);
          await this.pocketbaseService.getPocketBase().collection('cases').unsubscribe(caseID);

          // Give a small delay before reload to ensure image restore completed
          setTimeout(() => {
            console.log('🔄 [SUBSCRIBE] Reloading page...');
            window.location.reload();
          }, 1000);
        }
      },
      { /* options if needed */ }
    );
  }

  private async restoreImageIfMissing(caseRecord: Record<string, any>): Promise<void> {
    console.log('🔍 [IMAGE RECOVERY] Starting recovery check...');
    console.log('  - originalImage:', this.originalImage);
    console.log('  - caseRecord img:', caseRecord['img']);
    console.log('  - originalImageBlob cached:', !!this.originalImageBlob);

    try {
      if (!this.originalImage) {
        console.log('⏭️ [IMAGE RECOVERY] No original image to restore, skipping');
        return;
      }

      if (caseRecord['img']) {
        console.log('✅ [IMAGE RECOVERY] Image still present in record, no restore needed');
        return;
      }

      console.log('⚠️ [IMAGE RECOVERY] Image missing! Attempting to restore...');

      if (this.originalImageBlobPromise) {
        console.log('⏳ [IMAGE RECOVERY] Waiting for blob cache to complete...');
        await this.originalImageBlobPromise;
      }

      if (!this.originalImageBlob) {
        console.error('❌ [IMAGE RECOVERY] originalImageBlob missing, cannot restore image');
        console.log('  - This means the image fetch failed or hasn\'t completed yet');
        return;
      }

      const fileName = this.originalImage || 'case-image.jpg';
      const fileType = this.originalImageBlob.type || 'image/jpeg';
      const file = new File([this.originalImageBlob], fileName, { type: fileType });

      console.log('📤 [IMAGE RECOVERY] Uploading cached image...');
      console.log('  - fileName:', fileName);
      console.log('  - fileType:', fileType);
      console.log('  - fileSize:', file.size);

      await this.pocketbaseService.getPocketBase()
        .collection('cases')
        .update(this.CASE_ID, { img: file });

      console.log('✅ [IMAGE RECOVERY] Successfully restored missing image after backend processing');
    } catch (error) {
      console.error('❌ [IMAGE RECOVERY] Failed to restore image:', error);
      console.error('  Error details:', error);
    }
  }

  async loadFullCase(case_id: string) {
    const _case = await this.dataService.loadFullCaseById(case_id);
    if (!_case) {
      return null; // handle error
    }
    this.parseCase(_case);
    return _case;
  }

  // ============================
  // AUTOMATIC CONFIGURATION PROCESSING FOR NON-ADMIN USERS
  // ============================
  public isAutoProcessing = false;
  private autoProcessingInterval: any;

  /**
   * Starts the automatic configuration processing for non-admin users
   * This method waits for configuration to be available and then automatically triggers "Aktualisieren"
   */
  private startAutomaticConfigurationProcessing(): void {
    if (this.isAutoProcessing) return; // Prevent multiple instances

    console.log('🤖 Starting automatic configuration processing for non-admin user');
    this.isAutoProcessing = true;

    // Show a loading message to the user
    this.customToastrService.showSuccess('Fall wird automatisch konfiguriert. Bitte warten...');

    // Start checking for configuration availability
    this.checkForConfigurationAndProcess();
  }

  /**
   * Checks if configuration is available and processes it
   */
  private async checkForConfigurationAndProcess(): Promise<void> {
    let attempts = 0;
    const maxAttempts = 30; // 30 attempts with 2-second intervals = 60 seconds max wait

    this.autoProcessingInterval = setInterval(async () => {
      attempts++;
      console.log(`🔍 Checking for configuration (attempt ${attempts}/${maxAttempts})`);

      try {
        // Reload the case data to check for updated configuration
        const caseData = await this.dataService.loadFullCaseById(this.CASE_ID);

        if (caseData && this.hasValidConfigurationWithSchwerpunkt(caseData)) {
          console.log('✅ Configuration with schwerpunkt found! Triggering automatic update...');

          // Clear the interval
          clearInterval(this.autoProcessingInterval);
          this.isAutoProcessing = false;

          // Reparse the case with new data
          this.parseCase(caseData);

          // Wait a moment for the UI to update, then trigger Aktualisieren
          setTimeout(async () => {
            await this.triggerAutomaticUpdate();
          }, 1000);

          return;
        }

        if (attempts >= maxAttempts) {
          console.log('⏰ Timeout waiting for configuration');
          clearInterval(this.autoProcessingInterval);
          this.isAutoProcessing = false;
          this.customToastrService.showError('Automatische Konfiguration dauert länger als erwartet. Du kannst den Fall trotzdem manuell konfigurieren.');
          return;
        }

      } catch (error) {
        console.error('❌ Error checking for configuration:', error);
        if (attempts >= maxAttempts) {
          clearInterval(this.autoProcessingInterval);
          this.isAutoProcessing = false;
          this.customToastrService.showError('Fehler bei der automatischen Konfiguration. Bitte konfiguriere den Fall manuell.');
        }
      }
    }, 2000); // Check every 2 seconds
  }

  /**
   * Checks if the case has valid configuration with at least one schwerpunkt
   */
  private hasValidConfigurationWithSchwerpunkt(caseData: any): boolean {
    if (!caseData?.processed) {
      console.log('❌ No processed data found');
      return false;
    }

    const processed = caseData.processed;
    console.log('🔍 Checking configuration in processed data...');

    // Check each conf_tab for schwerpunkte
    for (let i = 0; i <= 3; i++) {
      const confTab = processed[`conf_tab${i}`];
      if (confTab?.config?.schwerpunkte && confTab.config.schwerpunkte.length > 0) {
        // Check if any schwerpunkt has content
        const hasContentInSchwerpunkt = confTab.config.schwerpunkte.some((s: string) => s && s.trim().length > 0);
        if (hasContentInSchwerpunkt) {
          console.log(`📋 Found schwerpunkt in conf_tab${i}:`, confTab.config.schwerpunkte);
          return true;
        } else {
          console.log(`📝 conf_tab${i} has schwerpunkte array but no content:`, confTab.config.schwerpunkte);
        }
      } else {
        console.log(`📝 conf_tab${i} does not have schwerpunkte or is empty`);
      }
    }

    // Also check map_chunks_focus_points as an alternative indicator
    const mapChunks = processed?.['map_chunks_focus_points'];
    if (mapChunks?.focusPoints && mapChunks.focusPoints.length > 0) {
      console.log('📋 Found focusPoints in map_chunks_focus_points:', mapChunks.focusPoints.length);
      // Check if any focus point has text content
      const hasContentInFocusPoints = mapChunks.focusPoints.some((fp: any) => fp.fp_text && fp.fp_text.trim().length > 0);
      if (hasContentInFocusPoints) {
        console.log('✅ Focus points have content, configuration is ready');
        return true;
      }
    }

    console.log('❌ No valid configuration with schwerpunkt found');
    return false;
  }

  /**
   * Triggers the automatic update (equivalent to clicking "Aktualisieren")
   */
  private async triggerAutomaticUpdate(): Promise<void> {
    try {
      console.log('🚀 Triggering automatic "Aktualisieren"...');
      this.customToastrService.showSuccess('Automatische Konfiguration wird angewendet...');

      // Call the create method with type 2 (update) and don't show success message
      // This will trigger the same backend processing and waiting logic as manual click
      await this.create(2, false);

      console.log('✅ Automatic update completed successfully (backend processing finished)');
      this.customToastrService.showSuccess('Fall wurde automatisch konfiguriert!');

      // Clean up sessionStorage
      sessionStorage.removeItem('autoRefreshed_' + this.CASE_ID);
      sessionStorage.removeItem('imageBlob_' + this.CASE_ID);
      console.log('🧹 [CLEANUP] Removed cached data from sessionStorage');

      // Navigate to success screen after backend processing is complete
      console.log('🎉 Redirecting to success screen...');
      setTimeout(() => {
        this.router.navigate(['/case-created', this.CASE_ID]);
      }, 1500); // Small delay to show the success message

    } catch (error) {
      console.error('❌ Error during automatic update:', error);
      this.customToastrService.showError('Fehler bei der automatischen Konfiguration. Bitte klicke manuell auf "Aktualisieren".');
    }
  }

  /**
   * Cleanup method for automatic processing
   */
  private cleanupAutomaticProcessing(): void {
    if (this.autoProcessingInterval) {
      clearInterval(this.autoProcessingInterval);
      this.autoProcessingInterval = null;
    }
    this.isAutoProcessing = false;

    // Clean up sessionStorage on component destroy
    if (this.CASE_ID) {
      sessionStorage.removeItem('imageBlob_' + this.CASE_ID);
    }
  }
}
